import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Modal, Button,
} from "@mui/material";
import { reCalibrateHeadingIcon } from ".././icons";


function ReCalibratePopup({open, onClose, handleRecalibrate}) {
    const [recalibrating, setRecalibrating] = useState(false);

    useEffect(() => {
        setRecalibrating(false);
    }, [open]);
    
    return (
        <Modal
            open={open}
            //onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="pricing-seasons-popup" sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '540px',
                //height: '200px',
                bgcolor: '#fff',
                borderRadius: '8px',
            }}>
                <Box className="popup-container">
                    {reCalibrateHeadingIcon}
                    <Box>
                        <div className='popup-title'>Pricing Seasons Updated</div>
                        <div className='popup-msg'>We’ve Detected Changes to Your Pricing Seasons. LodgIQ Will Automatically Refresh Pricing Recommendations During End-of-day Optimization. Need Updates Sooner? Trigger a Recalibration Now.</div>
                    </Box>
                    <Box className="action-buttons">
                        <Button onClick={onClose} className='btn-group navigate-cancel-button'>Cancel</Button>
                        {recalibrating && <Button className='btn-group navigate-save-button'>Recalibrating...</Button>}
                        {!recalibrating && <Button onClick={()=>{
                            handleRecalibrate();
                            setRecalibrating(true);
                            }} className='btn-group navigate-save-button'>Recalibrate</Button>}
                    </Box>
                </Box>
            </Box>

        </Modal>
    )
}

export default ReCalibratePopup